import type { BookmarkLocation } from '../../../utils/bookmarkLocation';
import Icon from '../../ui/Icon';

interface BookmarkLocationRowProps {
  location: BookmarkLocation;
}

function BookmarkLocationRow({ location }: BookmarkLocationRowProps) {
  return (
    <div className="text-bookmark-location mt-1 flex min-w-0 items-center">
      <span aria-hidden="true" className="inline-flex shrink-0">
        <Icon name={location.kind} size="sm" />
      </span>
      <span className="ml-1 max-w-[250px] min-w-0 truncate" title={location.label}>
        {location.label}
      </span>
    </div>
  );
}

export default BookmarkLocationRow;
